import { useState, useCallback } from 'react'
import { IFile } from 'apps/marketplace/pages/presource-carriers/types'
import uploadCarrierLanePreferenceCsv, {
  ICarrierLanePreferenceCsvResponse,
} from '../api/uploadCarrierCsv'

interface IUseUploadLanePreferences {
  uploadLanePreferences: (file: IFile) => Promise<ICarrierLanePreferenceCsvResponse | undefined>
  error: string
  setError: (msg: string) => void
  isUploading: boolean
}

export const useUploadLanePreferences = (): IUseUploadLanePreferences => {
  const [isUploading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  const uploadLanePreferences = useCallback(async (file: IFile): Promise<
    ICarrierLanePreferenceCsvResponse | undefined
  > => {
    setLoading(true)
    try {
      const results = await uploadCarrierLanePreferenceCsv(file)
      setLoading(false)
      setError('')
      return results
    } catch (err) {
      setError(err)
      setLoading(false)
      return undefined
    }
  }, [])

  return {
    uploadLanePreferences,
    error,
    setError,
    isUploading,
  }
}
